/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useState } from 'react';
// redux
import { useDispatch, useSelector } from 'react-redux';
// material
import { Icon } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './navitem_styles';
import { useNavigation } from 'utils/navigation';
import { setCurrentMenu } from 'state/slices/app';


/* ========== ~~~~~~~~~~ NAV ITEM ~~~~~~~~~~ ========== */
const NavItem = injectSheet(styles)((props) => {
	const dispatch = useDispatch()
	const currentPage = useSelector(state => state.app.currentPage);
	const currentMenu = useSelector(state => state.app.currentMenu)
	const handleActiveState = () => props.route ? currentPage.includes(props.route) : false;
	const [subitemsOpen, setSubitemsOpen] = useState(props.children && handleActiveState());
	const handleIndicator = () => subitemsOpen ? 'down' : 'right';

	useEffect(() => {
		if(!currentMenu) return
		if(props.text === currentMenu) setSubitemsOpen(true)
		else setSubitemsOpen(false)
	}, [currentMenu])

	const { handleNavigation } = useNavigation()
	const handleClick = () => {
		if(props.children) {
			setSubitemsOpen(!subitemsOpen)
		} else {
			handleNavigation(props.route)
		}
		dispatch(setCurrentMenu(props.text))
	}
	return (
		<div className={`navitem ${props.classes.navitem} isActive-${handleActiveState() || props.isActive} subitemsOpen-${subitemsOpen} isDisabled-${props.disabled}`}>
			{ !props.externalLink ?
        <div className={`item`} title={props.text} onClick={handleClick}>
          <Icon klass={`helpericon`} name={props.icon} animation={'none'} />
          <div className={`text`}>{props.text}</div>
          {props.children && <Icon klass={`indicator`} name={`angle-${handleIndicator()}`} animation={'none'} />}
        </div>
        :
        <a href={props.externalLink} className={`item`} title={props.text} target={'_blank'} rel={'noreferrer'}> 
          <Icon klass={`helpericon`} name={props.icon} animation={'none'} />
          <div className={`text`}>{props.text}</div>
        </a>
      }
			{props.children &&
				<div className={`subitems isActive-${subitemsOpen}`}>
					<div className={`line`} />
					<div className={`links`}>
						{props.children}
					</div>
				</div>
			}
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default NavItem;
